var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("QR Unmatched")]),_c('hr'),_c('flexibleFilter',{attrs:{"dealer_type":'DEALER',"fetch_filter":_vm.fetchFilter},on:{"onFilter":_vm.setFilterUrl}}),_c('div',{staticClass:"innerBox mt-5"},[_c('h5',{staticClass:"mb-2"},[_vm._v("QR Unmatched By Date")]),_c('qr-replacement-by-date',{attrs:{"filterUrl":_vm.filterUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }